import React, { FC } from 'react';
import { getLangFromCookies } from '../../../utils/cookies';
import { TRUSTPILOT_BUSINESS_ID, TrustpilotWidgetTemplate } from './model';

interface Props {
  width?: number;
}

export const TrustpilotWidgetMini: FC<Props> = ({ width = '100%' }) => {
  return (
    <div
      className="trustpilot-widget"
      data-locale={getLangFromCookies()}
      data-template-id={TrustpilotWidgetTemplate.Mini}
      data-businessunit-id={TRUSTPILOT_BUSINESS_ID}
      data-style-height="150px"
      data-style-width={width}
      data-theme="dark"
      style={{ width: width, margin: '0 auto' }}>
      <a href="https://trustpilot.com/review/bluevalet.fr" target="_blank" rel="noreferrer noopener">
        Trustpilot
      </a>
    </div>
  );
};
